// extracted by mini-css-extract-plugin
export default {"language":"Language_language__yFHxN","active":"Language_active__17+x6"};